// @flow
export { default } from './Heading';
export { default as HeadingLevel } from './HeadingLevel';
